import styled from 'styled-components';

/**
 * Layout only.
 *
 * Every typographic decision inside the table (row height, font size, paddings, the sortable
 * header) belongs to the application's `ui/table/Table`; nothing here may override it.
 */
export const Layout = styled.div`
  width: 100%;
`;

export const Toolbar = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
`;

export const SearchField = styled.div`
  min-width: 240px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

export const Summary = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0 8px;
`;

export const DrawerSection = styled.div`
  margin-bottom: 20px;
`;

/** One waiting order in the details panel: command on its own line, the facts underneath. */
export const OrderItem = styled.div`
  margin-bottom: 16px;
`;
